import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NotesTextNewCrumbs } from 'civil-status/constants/notes-text-breadcrumb';
import FormNotesText, { NotesTextForm } from 'civil-status/components/notes-text/form';
import { useNavigate } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const NotesTextNewPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const insertNoteText = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/crea-testo-annotazione`,
    {
      options: {
        method: 'POST',
      },
    }
  );

  const handleSubmit = useCallback(
    (values: NotesTextForm) => {
      (
        insertNoteText({
          data: {
            titolo: values.title || '',
            annotazione: values.text || '',
            tipoAnnotazione: values.type || '',
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/annotazioni');
      });
    },
    [insertNoteText, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={NotesTextNewCrumbs} />
      <FormNotesText
        title={'Nuova Annotazione'}
        onOk={handleSubmit}
        onCancel={() => {
          navigate('/stato-civile/annotazioni');
        }}
      ></FormNotesText>
    </Fragment>
  );
};

NotesTextNewPage.displayName = 'Notes Text New page component';

export default NotesTextNewPage;
